import React from "react";
import "./TMHBannerStyles.scss";

function TMHBannerNavBar({ children, ...restProps }) {
  return <nav {...restProps}>{children}</nav>
}

export default TMHBannerNavBar;
